import { Form, Formik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { Button, Container, Row, Col } from "react-bootstrap";
import FormikControl from "../../../componenets/FormikReusable/FormikControl";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import ProfileImagePreview from "../../../componenets/FormikReusable/ProfileImagePreview";
import profileImage from "../../../../src/profileImage.jpeg";
import SelectData from "./componenet/SelectFromData";
import { SignupSchema } from "./schemas/SignupSchema";
import { getStates, getCountries } from "./database/APIcall";
import AddressForm from "./componenet/AddressForm";

const initialValues = {
  firstName: "",
  lastName: "",
  email: "",
  password: "",
  cpassword: "",
  dob: "",
  phone: "",
  gender: "",
  website: "",
  role: "",
  file: "",
  country: "",
  address: {
    state: "",
    city: "",
    zipcode: "",
    addressline: "",
  },
};

const handleValidatePhone = (value) => {
  const isValid = isValidPhoneNumber(value);
  console.log({ isValid });
  return isValid;
};

const control = {
  INPUT: "input",
  DATE: "date",
  DATEMUI: "datemui",
  RADIO: "radio",
};

const genderOptions = [
  { key: "Male", value: "male" },
  { key: "Female", value: "female" },
];
const role = [
  { key: "Select Role", value: "" },
  { key: "Doctor", value: "doctor" },
  { key: "patiant", value: "patiant" },
];

const RegisterForm = () => {
  const fileref = useRef(null);

  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  const countryobj = {
    id: "",
    sortname: "",
    name: "Select Country",
    phoneCode: "",
  };

  useEffect(() => {
    getCountries().then((res) => {
      setCountries(res.countries);
    });
  }, []);
  countries?.unshift(countryobj);

  const onSubmit = (values, onSubmitProps) => {
    const findCountryName = countries?.find(
      (country) => country.id === parseInt(values.country)
    )?.name;

    values.country = findCountryName;
    console.log("formData", values);
    handleValidatePhone(values.phone);
    onSubmitProps.resetForm();
  };

  return (
    <>
      <Container style={{ width: "50%" }}>
        <Formik
          initialValues={initialValues}
          validationSchema={SignupSchema}
          onSubmit={onSubmit}
        >
          {(formik) => {
            const { errors, touched, values } = formik;
            return (
              <>
                <Form>
                  <Row>
                    <div
                      className="profile-pic "
                      style={{ paddingLeft: "210px" }}
                    >
                      {formik.values.file ? (
                        <ProfileImagePreview file={formik.values.file} />
                      ) : (
                        <img
                          src={profileImage}
                          height="200"
                          width="200"
                          onClick={() => fileref.current.click()}
                          style={{ cursor: "pointer", borderRadius: "50%" }}
                        />
                      )}

                      <input
                        ref={fileref}
                        type="file"
                        hidden
                        onChange={(e) =>
                          formik.setFieldValue("file", e.target.files[0])
                        }
                      />

                      {formik.errors.file ? (
                        <p style={{ color: "red" }}> {formik.errors.file} </p>
                      ) : (
                        ""
                      )}
                    </div>
                  </Row>
                  <Row>
                    <Col sm>
                      <FormikControl
                        control={control.INPUT}
                        name="firstName"
                        label="FirstName"
                      />
                    </Col>
                    <Col sm>
                      <FormikControl
                        control={control.INPUT}
                        name="lastName"
                        label="Lastname"
                      />
                    </Col>
                    <Col sm>
                      <FormikControl
                        control={control.INPUT}
                        name="email"
                        label="Email"
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm>
                      <FormikControl
                        control={control.INPUT}
                        name="password"
                        type="password"
                        label="Password"
                      />
                    </Col>
                    <Col sm>
                      <FormikControl
                        control={control.INPUT}
                        name="cpassword"
                        type="password"
                        label="Confirm Password"
                      />
                    </Col>
                  </Row>
                  <Row className="mt-3">
                    <Col sm>
                      <FormikControl
                        control={control.DATEMUI}
                        name="dob"
                        label="Date of Birth"
                      />
                    </Col>
                    <Col sm>
                      <PhoneInput
                        label="phoneNumber"
                        name="phone"
                        international
                        defaultCountry="IN"
                        countryCallingCodeEditable={false}
                        value={formik.values.phone}
                        onChange={(phone) => {
                          formik.setFieldValue("phone", phone);
                        }}
                      />
                    </Col>
                    <Col>
                      <FormikControl
                        control={control.RADIO}
                        label="Select Gender"
                        name="gender"
                        options={genderOptions}
                      />
                    </Col>
                  </Row>
                  <Row className="mt-3">
                    <FormikControl
                      control="select"
                      label="Select Role"
                      name="role"
                      options={role}
                    />
                  </Row>
                  <Row>
                    <Col sm>
                      <FormikControl
                        control={control.INPUT}
                        label="Website"
                        name="website"
                      />
                    </Col>
                  </Row>
                  <Row className="mt-3">
                    <SelectData
                      label="Select Country"
                      name="country"
                      options={countries}
                      countryobj={countryobj}
                    />
                    <AddressForm formik={formik} />
                  </Row>

                  <Button variant="primary" type="submit">
                    {" "}
                    Submit{" "}
                  </Button>
                  <Button
                    variant="primary"
                    type="reset"
                    className="m-3"
                    onClick={() => formik.resetForm()}
                  >
                    Reset
                  </Button>
                </Form>
              </>
            );
          }}
        </Formik>
      </Container>
    </>
  );
};

export default RegisterForm;
